import { Component, OnInit, OnDestroy } from '@angular/core';
import { GeneralService } from '@app/core/http';
import { VouchersService } from '@app/core/http/vouchers/vouchers.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AlertService } from 'ngx-venus';

@UntilDestroy()
@Component({
  selector: 'app-crypto-voucher',
  templateUrl: './crypto-voucher.component.html',
})
export class CryptoVoucherResultComponent implements OnInit, OnDestroy {
  constructor(
    private generalService: GeneralService,
    private voucherService: VouchersService,
    public alertService: AlertService
  ) {}

  cryptoMoney: any = null;
  isLoading = true;
  decisionPoint = 0;

  ngOnInit() {
    this.getTransactionCryptoMoneyInfo();
  }

  getTransactionCryptoMoneyInfo() {
    this.voucherService
      .getTransactionCryptoMoneyInfo()
      .pipe(untilDestroyed(this))
      .subscribe((response) => {
        if (
          response.cryptoMonies.length &&
          response.cryptoMonies[0].status === 'ACTIVE'
        ) {
          this.cryptoMoney = response.cryptoMonies[0];
          this.isLoading = false;
        } else if (this.decisionPoint < 7) {
          setTimeout(() => {
            this.getTransactionCryptoMoneyInfo();
            this.decisionPoint++;
          }, 5000);
        } else {
          this.cryptoMoney = 'DEACTIVE';
          this.isLoading = false;
        }
      });
  }

  backToMerchant(status?: string) {
    this.generalService.backToMerchant(status);
  }

  ngOnDestroy() {}
}
